<template>
  <a-select :disabled="diasbled" style="width: 100%" v-model="unitType" @change="handleChange">
    <a-select-option v-for="(item, index) in unitTypeList" :key="index" :value="item.code">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>
<script>
export default {
  props: {
    diasbled: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      unitType: undefined,
    }
  },
  computed: {
    unitTypeList() {
      return [
        {
          code: 'baseUnit',
          name: this.$t('基础单位'),
        },
        {
          code: 'saleUnit',
          name: this.$t('销售单位'),
        },
        {
          code: 'procurementUnit',
          name: this.$t('采购单位'),
        },
        {
          code: 'inventoryUnit',
          name: this.$t('库存单位'),
        },
        {
          code: 'otherUnit',
          name: this.$t('其他单位'),
        },
      ]
    },
  },
  mounted() {
    this.setDefault()
  },
  watch: {
    code() {
      this.setDefault()
    },
  },
  methods: {
    setDefault() {
      if (this.code && this.code !== 'undefined') {
        this.unitType = this.code
      } else {
        this.unitType = undefined
      }
    },
    handleChange(value) {
      this.unitType = value
      let upperStr = value.split('Unit')[0].toLocaleUpperCase()
      this.$emit('update:code', value)
      this.$emit('update:value', upperStr)
      let data = this.unitTypeList.find((item) => item.code === value)
      this.$emit('change', data)
    },
  },
}
</script>
